/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import { StaticPageContentService, IStaticPageContentMethods, PortfolioFormService, IPortfolioFormMethods, IPortfolioPreviewMethods, PortfolioPreviewService, ISavePortfolioMethods, SavePortfolioService, ISubmitPortfolioMethods, SubmitPortfolioService } from "./components";

export type DraftPortfolioPageAgent = IStaticPageContentMethods &
  IPortfolioFormMethods &
  ISavePortfolioMethods &
  ISubmitPortfolioMethods &
  IPortfolioFormMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new PortfolioFormService(),
    new PortfolioPreviewService(),
    new SavePortfolioService(),
    new SubmitPortfolioService(),
  ]
}

export const getAgent = () => {
  return createAgent<DraftPortfolioPageAgent>({
    plugins: getPlugins(),
  });
};